import React from 'react';
import Login from '../components/Login';

const DietitianLogin: React.FC = () => {
  return <Login userRole="dietitian" />;
};

export default DietitianLogin;

